import plugin from 'tailwindcss/plugin';

const children = plugin(function ({ addVariant }) {
	addVariant('children', '& > *');
});

export default children;
